import {
  removeLeadingZeros,
  removeRsFromValue,
  validatePriceQtyInput,
} from "../../../utils";
import { useContext, useEffect, useRef, useState } from "react";
import { ParagraphText, UBButton, UBInput } from "../../../Libraries";
import { LanguageContext } from "../../../context/LanguageContext";
import { formatNum } from "../../../oscar-pos-core/constants";
import { Box } from "@mui/material";
import "./styles.css";
import { PercentIcon } from "../../../assets/icons/icon";
import { analytics, triggerLogEvent } from "../../../config/firebase";

const DiscountAndTax = ({
  onUpdate,
  item,
  value,
  valueMethod,
  totalAmount,
  from = "discount",
  className,
  open,
  handleGetError = () => {},
  disabled,
  handleLogEvent = () => {},
  isEditMode = false,
}) => {
  const [I18n] = useContext(LanguageContext);
  const [inputType, setInputType] = useState(from == "discount" ? "rs" : "%");
  const [val, setVal] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const inputRef = useRef();
  const containerRef = useRef(); // Reference to the container

  useEffect(() => {
    if (open && !isEditMode) {
      inputRef?.current?.focus();
    }
  }, [open]);

  useEffect(() => {
    handleGetError({ error: errorMessage, from });
  }, [errorMessage, from]);

  useEffect(() => {
    setVal(value || "");
    setInputType(valueMethod || (from == "discount" ? "rs" : "%"));
  }, [value, valueMethod, from == "discount"]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!containerRef.current || containerRef.current.contains(event.target))
        return;
      if (disabled) {
        onUpdate({ ...item, valueMethod: inputType, value: 0 });
        return;
      }
      if (document.activeElement === inputRef.current) {
        triggerUpdate();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [val, inputType, disabled]);

  const handleInputTypeChange = (event, type) => {
    event.stopPropagation();
    setErrorMessage("");
    inputRef?.current?.focus();
    setInputType(type);
    checkValidation(val, false, type);
  };

  const handleChange = (key, value) => {
    const result = removeLeadingZeros(removeRsFromValue(value));
    if (validatePriceQtyInput(value)) {
      if (result.length >= 1 && val.length == 0) handleLogEvent();
      setVal(result);
    }
    checkValidation(result);
  };

  const checkValidation = (number, isBlurInput, type) => {
    if ((type || inputType) === "%" && number > 100) {
      setErrorMessage(
        `${I18n[from == "discount" ? "discount" : "tax"]} ${
          I18n.max_validation_message
        } 100%`
      );
      return true;
    } else if ((type || inputType) === "rs" && number > totalAmount) {
      setErrorMessage(
        `${I18n[from == "discount" ? "discount" : "tax"]} ${
          I18n.max_validation_message
        } ${formatNum(totalAmount)}`
      );
      return true;
    } else if ((type || inputType) === "%" && number == "0" && isBlurInput) {
      setErrorMessage(
        `${I18n[from == "discount" ? "discount" : "tax"]} ${I18n.cant_be} 0%`
      );
      return true;
    } else if ((type || inputType) === "rs" && number == "0" && isBlurInput) {
      setErrorMessage(
        `${I18n[from == "discount" ? "discount" : "tax"]} ${I18n.cant_be} 0`
      );
      return true;
    } else {
      setErrorMessage("");
      return false;
    }
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === "Tab") {
      triggerUpdate();
    }
  };

  const triggerUpdate = () => {
    const value =
      inputType === "rs"
        ? removeRsFromValue(inputRef.current.value)
        : inputRef.current.value;
    const isNotValidInput = checkValidation(value, true);
    if (isNotValidInput) {
      return;
    }
    triggerLogEvent(analytics, from === "discount" ? "pos_discount_applied" : "pos_tax_applied", {
      value: +val,
      method: inputType,
    });
    item = { ...item, valueMethod: inputType, value: +val };
    onUpdate(item);
  };
  return open ? (
    <Box
      className={`discountAndTaxContainer ${className || ""}`}
      ref={containerRef}
    >
      <Box
        className={`discountAndTaxInputWrapper ${
          from != "discount" ? "taxAddedBox" : ""
        }`}
      >
        <Box className="rupAndPercentBtn">
          {from == "discount" && (
            <UBButton
              id={`${from}_rs`}
              title={"Rs."}
              className={`rsButton ${inputType === "rs" && "active"}`}
              onClick={(event) => handleInputTypeChange(event, "rs")}
            />
          )}
          <UBButton
            id={`${from}_perc`}
            title={<PercentIcon />}
            className={`percentButton ${inputType === "%" ? "active" : ""}`}
            onClick={
              from == "discount"
                ? (event) => handleInputTypeChange(event, "%")
                : () => {
                    inputRef?.current?.focus();
                  }
            }
          />
        </Box>
        <UBInput
          inputId={`${from}_input_id`}
          baseClassname="discountAndTaxBaseInput"
          inputClassname="discountAndTaxInput"
          value={inputType !== "rs" ? val : val ? `Rs. ${val}` : ""}
          inputRef={inputRef}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          placeholder={
            from == "tax"
              ? `${I18n.enter_tax}`
              : inputType === "rs"
              ? `${I18n.enter} Rs.`
              : `${I18n.enter} %`
          }
          disabled={Boolean(disabled)}
        />
      </Box>
      {errorMessage && (
        <ParagraphText className={"fontSize11 foundationErrorRed"}>
          {errorMessage}
        </ParagraphText>
      )}
    </Box>
  ) : null;
};

export default DiscountAndTax;
